import { connect } from 'react-redux';
import bookingsModule from 'app/store/bookings';
import userModule from 'app/store/user';
import OrderSuccess from './Order.component';

const { clearBooking, clearCode, barcodeRequest, QRCodeRequest } = bookingsModule.actions;
const { transactionsRequest } = userModule.actions;

const mapStateToProps = ({ bookings: { booking, code } }) => ({
  booking,
  code
});

const mapDispatchToProps = dispatch => ({
  clearBooking: () => dispatch(clearBooking()),
  clearCode: () => dispatch(clearCode()),
  fetchCode: (isPaid, code) => dispatch(isPaid ? QRCodeRequest(code) : barcodeRequest(code)),
  fetch: transactionsRequest
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderSuccess);
